import z from 'zod'

import {zFormRules} from '@/src/config/validation'

/**
 * Call request form validation schema
 */
export const CallRequestSchema = z.object({
  name: z.string({message: 'Обязательное поле'}).min(1, 'Обязательное поле'),
  phone: zFormRules.phone,
})

/**
 * Feedback form validation schema
 */
export const FeedbackSchema = z.object({
  name: z.string({message: 'Обязательное поле'}).min(1, 'Обязательное поле'),
  phone: zFormRules.phone,
  email: zFormRules.email.refine(email => email && email.length > 0, 'Обязательное поле'),
  question: z.string({message: 'Обязательное поле'}).min(1, 'Обязательное поле'),
})

/**
 * Email subscription validation schema
 */
export const SubscriptionSchema = z.object({
  email: z.string().email('Некорректный формат'),
})

export type CallRequestData = z.infer<typeof CallRequestSchema> & {
  captcha_token: string
}

export type FeedbackData = z.infer<typeof FeedbackSchema> & {
  captcha_token: string
}

export type SubscriptionData = z.infer<typeof SubscriptionSchema>

/**
 * Footer menu title mapping
 */
export const menuTitles: Record<keyof LayoutData['footer']['menu'], string> = {
  footer_catalog: 'Каталог',
  footer_help: 'Помощь',
  footer_info: 'Информация',
}

/**
 * Modal state interface
 */
export interface FooterModalsState {
  callRequest: boolean
  feedback: boolean
}
